import logo_footer from "./assets/logo-footer3.png";
import ico_face from "./assets/ico-face.png";
import ico_you from "./assets/ico-you.png";
import ico_inst from "./assets/ico-inst.png";
import logo_tipddy from "./assets/logo-tipddy.png";
import "./index.css";
import { useTheme } from "../../contexts/ThemeContext";
import { Link } from "react-router-dom";
import { useConfig } from "../../contexts/config";
import React from "react";
import { readableColor } from "polished";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import { LinkedIn } from "@mui/icons-material";

export const Footer = () => {
  const { config } = useConfig();
  const theme = useTheme();
  const [contrastColorSecondary, setcontrastColorSecondary] =
    React.useState("green");

  React.useEffect(() => {
    if (theme && theme.colors.secondary_light) {
      setcontrastColorSecondary(
        readableColor(theme.colors.primary_light, "#000", "#fff", false)
      );
    }
    // eslint-disable-next-line
  }, [theme]);
  return (
    <>
      {/* <div className="wrapper fon-footer sale-movil" style={theme.styles.nav}>
        <div className="container"> */}
      <div
        style={{ backgroundColor: theme.colors.backgroundColorFooter }}
        className="flex flex-col justify-between items-center tablet:items-end gap-8 tablet:gap-0 px-[3rem] tablet:px-[6rem] tablet:flex-col tablet:p-[4rem] "
      >
        <div className="flex flex-col gap-10 tablet:gap-0 tablet:flex-row tablet:justify-between w-full">
          <div className="flex flex-col tablet:flex-row gap-16 ">
            <div className="flex flex-col items-center tablet:items-start">
              <p
                className="text-3xl font-semibold mb-4"
                style={{ color: contrastColorSecondary }}
              >
                Accesos directos
              </p>
              <ul className="!list-none flex flex-col gap-3 [&_a]:mx-0">
               {/*  <li className="px-0">
                  <a
                    href="https://www.academia-tecnigen.cl/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary }}
                  >
                    Academia
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.academia-tecnigen.cl/otec/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline "
                    style={{ color: contrastColorSecondary }}
                  >
                    OTEC Academia Tecnigen
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.academia-tecnigen.cl/cinia/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary }}
                  >
                    CINIA
                  </a>
                </li> */}
                <li>
                  <Link
                    to="/listcourses/progress"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary }}
                  >
                    Progreso
                  </Link>
                </li>
              </ul>
            </div>

            {/* Social media column */}
            <div className="flex flex-col items-center tablet:items-start  [&_a]:mx-0">
              <p
                className="text-3xl font-semibold mb-4"
                style={{ color: contrastColorSecondary }}
              >
                Conecta con nosotros
              </p>
              <div className="flex gap-4">
                {/* <a
                  href="https://www.facebook.com/academia.tecnigen"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <FacebookIcon
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a> */}
                <a
                  href="https://www.instagram.com/academiatecnigen/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <InstagramIcon
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/academiatecnigen/?viewAsMember=true"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <LinkedIn
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="w-[16rem]  tablet:w-[30rem] h-auto flex self-center tablet:items-center tablet:justify-center  mb-4">
            <img
              src={
                config.config.theme &&
                (theme && theme.mode === "light"
                  ? config.config.theme.logo
                  : config.config.theme.theme_logo_dark)
              }
              alt="Academia Tecnigen Logo"
              className="max-w-full  max-h-[10rem] object-contain"
            />
          </div>
        </div>

        {/* Tipddy attribution - at the bottom */}
        <div className="flex flex-row items-center gap-2 py-4 mt-8 border-t border-gray-700/30 w-full justify-center">
          <img
            src={logo_tipddy}
            alt="Tipddy Logo"
            className="h-6 w-auto object-contain"
          />
          <p
            className="text-2xl font-medium opacity-80 flex items-center"
            style={{ color: contrastColorSecondary }}
          >
            &copy; {new Date().getFullYear()} Powered by Tipddy
          </p>
        </div>
      </div>
    </>
  );
};
